/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRef,
  ProgramTypeRefOptional,
  ProgramTypeRefMetaI,
  ProgramTypeRefTrackedI,
} from "./program-type-ref";
import { ProgramTypeRefTracked, ProgramTypeRefMeta } from "./program-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";

/**
 *
 * @export
 * @interface ClassSignupRequestDTO
 */
export interface ClassSignupRequestDTOOptional {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSignupRequestDTO
   */
  classInstance?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassSignupRequestDTO
   */
  program?: ProgramTypeRefOptional;
  /**
   *
   * @type {PersonRef}
   * @memberof ClassSignupRequestDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassSignupRequestDTO
   */
  signupType?: SignupTypeEnum;
}

export interface ClassSignupRequestDTO extends ClassSignupRequestDTOOptional {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSignupRequestDTO
   */
  classInstance: UnifiedClassInstanceRef;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassSignupRequestDTO
   */
  program: ProgramTypeRef;
  /**
   *
   * @type {PersonRef}
   * @memberof ClassSignupRequestDTO
   */
  personId: PersonRef;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassSignupRequestDTO
   */
  signupType?: SignupTypeEnum;
}

export interface ClassSignupRequestDTOTrackedI {
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSignupRequestDTO
   */
  classInstance?: UnifiedClassInstanceRefTrackedI;
  classInstanceIsSet: boolean;
  /**
   *
   * @type {ProgramTypeRef}
   * @memberof ClassSignupRequestDTO
   */
  program?: ProgramTypeRefTrackedI;
  programIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof ClassSignupRequestDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassSignupRequestDTO
   */
  signupType?: SignupTypeEnum;
  signupTypeIsSet: boolean;
}

transformDatesMap.set(
  "ClassSignupRequestDTO",
  function (model: ClassSignupRequestDTO) {
    const transformDatesclassInstance = transformDatesMap.get(
      "UnifiedClassInstanceRef",
    );
    if (transformDatesclassInstance && model.classInstance) {
      transformDatesclassInstance(model.classInstance);
    }
    const transformDatesprogram = transformDatesMap.get("ProgramTypeRef");
    if (transformDatesprogram && model.program) {
      transformDatesprogram(model.program);
    }
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
  },
);

export type ClassSignupRequestDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  classInstance: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  program: PropertyMeta<ProgramTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  signupType: PropertyMeta<SignupTypeEnumMetaI>;
}>;

export var ClassSignupRequestDTOMeta: ClassSignupRequestDTOMetaI =
  {} as ClassSignupRequestDTOMetaI;
ClassSignupRequestDTOMeta = typeMeta("ClassSignupRequestDTO", {
  classInstance: propertyMeta(
    "classInstance",
    false,
    true,
    false,
    UnifiedClassInstanceRefMeta,
  ),
  program: propertyMeta("program", false, true, false, ProgramTypeRefMeta),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  signupType: propertyMeta(
    "signupType",
    false,
    false,
    false,
    SignupTypeEnumMeta,
  ),
});

const metaI = ClassSignupRequestDTOMeta;

registerMeta(() => {});

export class ClassSignupRequestDTOTracked implements ClassSignupRequestDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  classInstance__I?: UnifiedClassInstanceRefTracked = undefined;
  classInstanceIsSet: boolean = false;
  set classInstance(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.classInstance__I = v;
      this.classInstanceIsSet = true;
    } else {
      this.classInstance__I = v || undefined;
      this.classInstanceIsSet = true;
    }
    this.changeTracker = true;
  }
  get classInstance() {
    return this.classInstance__I;
  }
  program__I?: ProgramTypeRefTracked = undefined;
  programIsSet: boolean = false;
  set program(v: undefined | ProgramTypeRefTracked) {
    if (v !== undefined) {
      this.program__I = v;
      this.programIsSet = true;
    } else {
      this.program__I = v || undefined;
      this.programIsSet = true;
    }
    this.changeTracker = true;
  }
  get program() {
    return this.program__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  signupType__I?: SignupTypeEnum = undefined;
  signupTypeIsSet: boolean = false;
  set signupType(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.signupType__I = v;
      this.signupTypeIsSet = true;
    } else {
      this.signupType__I = v || undefined;
      this.signupTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupType() {
    return this.signupType__I;
  }
  constructor(config?: ClassSignupRequestDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.classInstance?.setIds();

    this.program?.setIds();

    this.personId?.setIds();
  }
  assignFrom(
    config: ClassSignupRequestDTOOptional,
    options?: AssignOptions,
  ): ClassSignupRequestDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.classInstance &&
      this.classInstanceApplyFilter(optionsRequired.filter)
    ) {
      this.classInstance = new UnifiedClassInstanceRefTracked(
        config.classInstance,
        options,
      );
      if (optionsRequired.unassign) this.classInstanceIsSet = false;
      else this.classInstanceIsSet = true;
    }
    if (config.program && this.programApplyFilter(optionsRequired.filter)) {
      this.program = new ProgramTypeRefTracked(config.program, options);
      if (optionsRequired.unassign) this.programIsSet = false;
      else this.programIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.signupType &&
      this.signupTypeApplyFilter(optionsRequired.filter)
    ) {
      this.signupType = config.signupType;
      if (optionsRequired.unassign) this.signupTypeIsSet = false;
      else this.signupTypeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassSignupRequestDTOTrackedI {
    const cloned = {} as ClassSignupRequestDTOTrackedI;
    if (
      this.classInstanceIsSetDeep() &&
      this.classInstanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classInstanceIsSet = true;
      cloned.classInstance = this.classInstance?.removeUnset(filter);
    } else {
      //cloned.classInstanceIsSet = false
    }
    if (
      this.programIsSetDeep() &&
      this.programApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programIsSet = true;
      cloned.program = this.program?.removeUnset(filter);
    } else {
      //cloned.programIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.signupTypeIsSetDeep() &&
      this.signupTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupTypeIsSet = true;
      cloned.signupType = this.signupType;
    } else {
      //cloned.signupTypeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassSignupRequestDTOTrackedI {
    if (!this.classInstanceApplyFilter(filter)) this.classInstanceIsSet = false;
    this.classInstance?.unassignAll(filter);

    if (!this.programApplyFilter(filter)) this.programIsSet = false;
    this.program?.unassignAll(filter);

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.signupTypeApplyFilter(filter)) this.signupTypeIsSet = false;

    return this;
  }
  classInstanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupRequestDTOMeta.classInstance,
      ClassSignupRequestDTOMeta,
      this.classInstance,
      this,
    );
  }
  classInstanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classInstanceIsSet && this.classInstanceApplyFilter(filter))
      return true;
    return this.classInstance?.anySet(filter) == true;

    return false;
  }
  programApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupRequestDTOMeta.program,
      ClassSignupRequestDTOMeta,
      this.program,
      this,
    );
  }
  programIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programIsSet && this.programApplyFilter(filter)) return true;
    return this.program?.anySet(filter) == true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupRequestDTOMeta.personId,
      ClassSignupRequestDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  signupTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupRequestDTOMeta.signupType,
      ClassSignupRequestDTOMeta,
      this.signupType,
      this,
    );
  }
  signupTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupTypeIsSet && this.signupTypeApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.classInstanceIsSetDeep(filter)) return true;
    if (this.programIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.signupTypeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
